import { ProtectiveFunctionLocation } from "./models/protectiveFunctionLocation";
import * as moment from "moment";
import { countrydetails } from "./models/countrydetails";

export const tagNameDelimiter = ",";

export const isSingleDevice = (voting: string) => {
  return !voting || voting === "1oo1" || voting === "H-PAT" 
}

export interface IMooN {
  M: number;
  N: number;
}

export const getUrlVars = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams;  
}

export const pfdToSil = (pfd: number) => {
    if (pfd >= 0.1) {
        return 0;
    }
    else if ((pfd >= 0.01) && (pfd < 0.1)) {
        return 1;
    }
    else if ((pfd >= 0.001) && (pfd < 0.01)) {
        return 2;
    }
    else if ((pfd >= 0.0001) && (pfd < 0.001)) {
        return 3;
    }
    else if (pfd < 0.00001) {
        return 4;
    }
    else {
        return 4;
    }
}

export const getConfigRedundancy = (voting: string): "REN" | "NREN" => {
    // These come from the HTMLImages/Image/ files
    const redundantConfigTypes = [
        "1oo2",
        "1oo3",
        "2oo3",
        "Device1oo2",
        "Device1oo3",
        "Device2oo3",
        "Duplicated",
        "Triplex"
    ]; 

    return redundantConfigTypes.indexOf(voting) > -1
        ? "REN"
        : "NREN";
}

export const formatMooNVoting = (voting: IMooN, isPrefix: boolean = false): string => {
  var prefix = "";
  if (isPrefix) 
    prefix = "MooN";
  
  if (voting.M == 0 && voting.N == 0)
    return `${prefix}0oo0`;
  else
    return `${prefix}${voting.M}oo${voting.N}`;
} 

export const isMooNVotingType = (voting: string) => {  
  if (!voting)
    return false;
  return new RegExp(/MooN([\d]*)oo([\d]*)/).test(voting);
}

export const parseMooNVoting = (voting: string): IMooN => {
  let result = {
    M: 0,
    N: 0
  } as IMooN;
  if (!voting || voting == "MooN")
    return result;

  if (isMooNVotingType(voting)) {
    var match = voting.match(/MooN([\d]*)oo([\d]*)/);
    if (match && match.length >= 3) {
      result.M = parseInt(match[1]);
      result.N = parseInt(match[2]);
    }
  }
  return result;
}

export const parseVoting = (voting: string): IMooN => {
  const result = {
    M: 1,
    N: 1
  } as IMooN;
  
  const match = voting?.match(/^([\d]*)oo([\d]*)$/);
  if (match && match.length >= 2) {
    result.M = parseInt(match[1]);
    result.N = parseInt(match[2]);
  }
  return result;
}

export const votingToConfigType = (voting: string) => {
    //normal device
    if (voting === 'Device1oo1') {
        return "NOD";
    }
    else if ((voting === 'Device1oo2') || (voting === 'Device2oo2')) {
        return "NTD";
    }
    else if ((voting === 'Device1oo3') || (voting === 'Device2oo3') || (voting === 'Device3oo3')) {
        return "NRD";
    }
    //complex device
    else if (voting === '1oo1') {
        return "COD";
    }
    else if ((voting === '1oo2') || (voting === '2oo2')) {
        return "CTD";
    }
    else if ((voting === '1oo3') || (voting === '2oo3') || (voting === '3oo3')) {
        return "CRD";
    }
    else if (isMooNVotingType(voting)) {
      return "MOON";
    }
    else if (voting === 'Simplex') {
        return "SIM";
    }
    else if (voting === 'Duplex' || voting === 'Duplicated') {
        return "DUP";
    }
    else if (voting === 'Triplex') {
        return "TRI";
    }
}

export const locationType = (location: ProtectiveFunctionLocation): "Input" | "Action" | "Support System" => {
  const inputLocations = ["INP1", "INP2", "INP3", "INP4", "INP5"];
  const actionLocations = ["A1O1", "A1O2", "A1O3", "A1O4", "A1O5"];
  const supportLocations = ["SSO1", "SSO2"];
  if (inputLocations.indexOf(location) > -1) {
    return "Input";
  } else if (actionLocations.indexOf(location) > -1) {
    return "Action";
  } else if (supportLocations.indexOf(location) > -1) {
    return "Support System";
  } else {
    throw new Error("Unknown location type");
  }
}

export const lockedVotingDevices = [
  "IAD",
  "IADR",
  "IADRM",
  "IANDV",
  "IAWRC",
  "IAWRM",
  "UPSDM",
  "UPSDT",
  "UPSET"
];

export const getuserDateTimeFormat = () => {
  var dateTimeFormat = getCookieValue("DateFormat");
  if (dateTimeFormat.indexOf('DateFormat') > -1) {
    var netFormat = dateTimeFormat.split("DateFormat=")[1];

    if (netFormat == "M/dd/yyy") {
      return "MM/DD/YYYY";
    } else if (netFormat == "dd/M/yyy") {
      return "DD/MM/YYYY";
    } else if (netFormat == "dd-MMM-yyy") {
      return "DD-MMM-YYYY";
    } else if (netFormat == "MMM-dd-yyy") {
      return "MMM-DD-YYYY";
    } else {
      return null;
    }
  }
  return null;
}

export const formatDate = (date: Date, format: string = null) => {
  var userDateTimeFormat = format ?? getuserDateTimeFormat();
  if (userDateTimeFormat == null) {
    userDateTimeFormat = "ll";
  }
  if (date == null) {
    return "";
  } else {
    return moment(date).format(userDateTimeFormat);
  }
}

export const getCookieValue = (key: string) => {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}

export const formatNumberNotation = (value: number): string => {
    if (value == null) {
        return '';
    }

    var formatted = value.toExponential(2).toString().replace('e', 'E');

    if (formatted.indexOf('+') != -1) {
        var parts = formatted.split('+');
        return `${parts[0]}+${(parts[1].length < 2 ? `0${parts[1]}` : parts[1])}`;
    }

    if (formatted.indexOf('-') != -1) {
        var parts = formatted.split('-');
        return `${parts[0]}-${(parts[1].length < 2 ? `0${parts[1]}` : parts[1])}`;
    }

    return '';
}

export const formatPieChartLabels = (chartData: countrydetails[]): countrydetails[] => {
    chartData.map(cd => {
        if (cd.countryname?.indexOf('%') == -1) {
            cd.countryname = `${cd.countryname} ${(Math.round(cd.total * 100) / 100).toFixed(0)}%`;
        }
    });

    return chartData;
}